/** Trade Org dispatcher — routes on org.association_type into the
 *  four segregated variants. Falls back to the legacy TradeOrgDashboard
 *  when we don't have the association_type field yet (older orgs).
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import ProducerDashboard from "./variants/producer/ProducerDashboard";
import WorkerDashboard   from "./variants/worker/WorkerDashboard";
import WriterDashboard   from "./variants/writer/WriterDashboard";
import GeneralDashboard  from "./variants/general/GeneralDashboard";
import LegacyTradeOrgDashboard from "@/pages/TradeOrgDashboard";

export default function TradeOrgDashboardRouter() {
  const [orgType, setOrgType] = useState(null);
  const [associationType, setAssociationType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/onboard/me/organization")
       .then(({ data }) => {
         setOrgType(data.organization?.type || "");
         setAssociationType(data.organization?.association_type || "");
       })
       .catch(() => {})
       .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="mx-auto max-w-7xl px-6 py-16 text-center text-white/55">Loading…</div>;
  }

  // Legacy — no association_type set yet
  if (!associationType) return <LegacyTradeOrgDashboard />;

  switch (associationType) {
    case "producer": return <ProducerDashboard />;
    case "worker":   return <WorkerDashboard />;
    case "writer":   return <WriterDashboard />;
    case "general":
    default:         return <GeneralDashboard />;
  }
}
